import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonCol, IonGrid, IonRow, modalController, IonButton, IonIcon } from "@ionic/vue";
import { computed, onMounted, reactive, ref } from "vue";
import { useForm } from "vee-validate";

import InputSimple from "@/components/input/InputSimple.vue";
import SelectSimple from "@/components/selects/SelectSimple.vue";
import ButtonFix from "@/components/button/ButtonFix.vue";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import LanguageDropdown from "@/components/selects/LanguageDropdown.vue";

import PhoneDialCodeDropdown from "@/components/selects/PhoneDialCodeDropdown.vue";

import { useLocationStore } from "@/stores/locations";
import { useUserStore } from "@/stores/user";
import { useSupplierStore } from "@/stores/suppliers";

import { interactionFeedbackToast } from "@/functions/baseToast";
import { isApp } from "@/functions/enviroment";

import { APP_LANGUAGES, INPUT_MODE, INPUT_TYPE } from "@/types/enum/ionicEnum";
import { chevronBack } from "ionicons/icons";
import { requestRaw } from "@/api-connectors/basicRequests";

interface AiCall {
    locationId: string,
    supplierId: string,
    language: APP_LANGUAGES,
    phone: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AiCallModal',
  setup(__props) {

const supplierStore = useSupplierStore()

const locationStore = useLocationStore()
const userStore = useUserStore()

const phoneIsValid = ref(false);

const { meta, validateField } = useForm({
    validationSchema: {
        locationId: 'required',
        supplierId: 'required',
        language: 'required',
        phone: (value: string) => {
            if (!value || value === '') return false
            if (!phoneIsValid.value) return false
            return true // valid
        }
    }
})

function onPhoneValid(valid: boolean) {
    phoneIsValid.value = valid
    validateField('phone')
}

const aiCallForm = reactive<AiCall>({
    locationId: '',
    supplierId: '',
    language: APP_LANGUAGES['DE'],
    phone: '',
})

const aiSupportedSuppliers = computed(() => supplierStore.suppliers.data.filter((supplier) => supplier.hasCallBot))

const changeSupplierId = (supplierId: unknown) => {
    if (typeof supplierId === "string") {
        Object.assign(aiCallForm, { ...aiCallForm, supplierId })
    }
}

const changeCallLanguage = (language: string) => {
    Object.assign(aiCallForm, { ...aiCallForm, language })
}

const setup = (): void => {
    const oneSupplierId = aiSupportedSuppliers.value.length === 1 ? aiSupportedSuppliers.value[0].id : '';

    if (locationStore.activeLocation?.id) Object.assign(aiCallForm, {
        locationId: locationStore.activeLocation.id,
        supplierId: oneSupplierId || '',
        language: userStore.sessionInfo?.callBot?.language || localStorage.getItem('localeLanguage') || 'DE',
        phone: userStore.sessionInfo.callBot?.phone || userStore.sessionInfo.phone || locationStore.activeLocation.phone
    })
}

const aiCallRequest = async (): Promise<void> => {
    const { locationId, supplierId, language, phone } = aiCallForm
    const form = {
        language: language,
        phone: phone.replace(/[^\d+]/g, ''), /* normalize */
    }

    const response = await requestRaw({
        method: 'POST',
        route: `locations/${locationId}/suppliers/${supplierId}/callMe`,
        body: form
    })

    userStore.getMe() // update saved data

    await interactionFeedbackToast(Boolean(response), {
        type: 'aiCall',
        id: 'ai-call',
    }, { cssClass: 'toast-offset-50' }, true)

    setTimeout(() => modalController.dismiss(), 2000)
}

onMounted(() => setup())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalControllerBase, { contentClass: "background-gradient-background purple-light-color" }, {
    header: _withCtx(() => [
      _createVNode(CustomHeader, {
        "back-button": "",
        title: _ctx.$t('titleRoute.aiCall')
      }, {
        start: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss())),
            class: "purple-light-color"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(chevronBack) }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("button.back")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), {
        class: _normalizeClass(["p-2", { 'center-web': !_unref(isApp)() }])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center py-2" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "picture-block" }, [
                    _createElementVNode("img", {
                      src: "assets/image/octoBot.png",
                      class: "picture octo-shadow"
                    })
                  ], -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "fs-smaller purple-light-color" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`alert.selectSupplier`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), {
            class: _normalizeClass({ 'ion-justify-content-center': !_unref(isApp)() })
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), {
                class: _normalizeClass({ 'web-input-width': !_unref(isApp)() })
              }, {
                default: _withCtx(() => [
                  _createVNode(SelectSimple, {
                    "model-value": aiCallForm.supplierId,
                    onChange: changeSupplierId,
                    class: "grey4-grey4-background inherit-background purple-purple-color max-width chevron-select unset-max-width",
                    placeholder: _ctx.$t('messages.setting.delivererSelect'),
                    options: aiSupportedSuppliers.value,
                    valueKey: "id",
                    textKey: "name",
                    disabled: aiSupportedSuppliers.value.length <= 1
                  }, null, 8, ["model-value", "placeholder", "options", "disabled"])
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "fs-smaller purple-light-color" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`label.aiCallbackPhone`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), {
            class: _normalizeClass({ 'ion-justify-content-center': !_unref(isApp)() })
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), {
                class: _normalizeClass(["center-x", { 'web-input-width': !_unref(isApp)() }])
              }, {
                default: _withCtx(() => [
                  _createVNode(PhoneDialCodeDropdown, {
                    phone: aiCallForm.phone,
                    "onUpdate:phone": _cache[1] || (_cache[1] = ($event: any) => ((aiCallForm.phone) = $event)),
                    "init-coutry": "de",
                    onValid: onPhoneValid
                  }, null, 8, ["phone"])
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(IonRow), { class: "mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "fs-smaller purple-light-color" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`label.aiCallLanguage`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center-x" }, {
                default: _withCtx(() => [
                  _createVNode(LanguageDropdown, {
                    language: aiCallForm.language,
                    changeFunction: changeCallLanguage,
                    class: "center-x",
                    style: {"width":"100%"}
                  }, null, 8, ["language"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), { class: "mt-4" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center-x" }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFix, {
                    disabled: !_unref(meta).valid,
                    class: "coral-light-background inherit-background light-coral-color inherit-color",
                    onClick: aiCallRequest
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('button.requestAiCall')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})